import React from "react";

const TopTextSection = ({ html }) => {
  return <div className="mb-[30px]" dangerouslySetInnerHTML={{ __html: html }}></div>;
};

export default TopTextSection;
